import React, { useState } from "react";
import styles from "../../../views/ReportView/ReportView.module.css";
import IconAnimation from "../../iconAnimation/iconAnimation";
import NotReportViewData from "../../NotReportViewData/NotReportView";
import { MdWork } from "react-icons/md";

const EmployerInformation = ({ data }) => {
  const [user, setUser] = useState(data);
  const [isEditing] = useState(false);

  const handleInputChange = (event) => {
    const { name, value } = event.target;
    setUser({ ...user, [name]: value });
  };

  return (
    <div className={styles.informacionEmpleador} id="empleador">
      <div className={styles.sectionTitle2}>
        <h2 className={styles.sectionTitleH2}>Información Empleador</h2>
        <IconAnimation />
      </div>
      {!user || !user.EmployerInformation ? (
        <NotReportViewData title="Información Empleador" Icon={MdWork} />
      ) : (
        <>
          <label className={styles.inputLabel}>
            Empleador:
            <input
              className={styles.inputField}
              type="text"
              name="employer"
              value={user.EmployerInformation.employer || ""}
              onChange={handleInputChange}
              readOnly={!isEditing}
            />
          </label>
          <label className={styles.inputLabel}>
            Antigüedad en la actividad:
            <input
              className={styles.inputField}
              type="text"
              name="activitySeniority"
              value={user.EmployerInformation.activitySeniority || ""}
              onChange={handleInputChange}
              readOnly={!isEditing}
            />
          </label>
          <label className={styles.inputLabel}>
            Domicilio empleador:
            <input
              className={styles.inputField}
              type="text"
              name="employerDomicile"
              value={user.EmployerInformation.employerDomicile || ""}
              onChange={handleInputChange}
              readOnly={!isEditing}
            />
          </label>
          <label className={styles.inputLabel}>
            Actividad laboral:
            <input
              className={styles.inputField}
              type="text"
              name="WorkActivity"
              value={user.EmployerInformation.WorkActivity || ""}
              onChange={handleInputChange}
              readOnly={!isEditing}
            />
          </label>
          <label className={styles.inputLabel}>
            Actividad que desarrolla:
            <textarea
              className={styles.inputField}
              type="text"
              name="ActivityBeingCarriedOut"
              value={user.EmployerInformation.ActivityBeingCarriedOut || ""}
              onChange={handleInputChange}
              readOnly={!isEditing}
            />
          </label>
        </>
      )}
    </div>
  );
};

export default EmployerInformation;
